import api from '@/services/api';
export default {
    async exportCompanyDetailResults({ dispatch, commit }, params) {
        const data = await api.get(`/api/userProcess/export-company-process`, { params, responseType: 'blob' }).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'DetailReport.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async getQuizResults({ dispatch, commit }, params) {
        const { data } = await api.get('/api/quizResult/get-by-companies', { params });
        if (data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_QUIZ_RESULTS', data.data);
        }
        return data;
    },
    async exportQuizResults({ dispatch, commit }, params) {
        const data = await api.get(`/api/quizResult/export-results-in-company`, { params, responseType: 'blob' }).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'QuizResults.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async getAttendanceResults({ dispatch, commit }, params) {
        const response = await api.get(`/api/attendances/get-by-company`, {
            params: params
        });
        return response.data;
    },
    async exportCompanyAttendanceResults({ dispatch, commit }, params) {
        const data = await api.get(`/api/attendances/export-by-company`, { params, responseType: 'blob' }).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'AttendanceReport.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async getDetailStatics({ dispatch, commit }, params) {
        const { data } = await api.get('/api/userProcess/companies-process', { params });
        if (data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_USER_PROCESS_DETAIL_DATA', data.data);
        }
        return data;
    },
}